import L from "leaflet";
import carTripIconUrl from "../../../assets/carTripIcon.svg";

export const createCarIcon = (bearingDeg: number) =>
  L.divIcon({
    className: "",
    html: `<img src="${carTripIconUrl}" width="43" height="50" style="transform:rotate(${bearingDeg}deg);transform-origin:center;display:block" />`,
    iconSize: [43, 50],
    iconAnchor: [21, 25],
    // Leaflet only accepts pixel offsets
    tooltipAnchor: [0, -25],
  });
